import { Fieldset } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconCopy } from '@calendly/ui/components/glyphs/IconCopy';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CopyIcon } from '@calendly/ui/components/icons';
import { BareItem, Group, Menu } from '@calendly/ui/components/menu';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
const copyButtonWrapperIsV4Css = "c1jkislg";
const copyButtonWrapperCss = "c12pydnw";
const titleCss = "toaqgr8";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'legend';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const checkboxItemCss = "c1ex5581";
const CheckboxItem = forwardRef((props, ref) => {
  const as = 'label';
  return <BareItem ref={ref} {...props} as={as} className={classNames(checkboxItemCss, props.className)} />;
});
const checkboxContainerCss = "cad886m";
const CheckboxContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(checkboxContainerCss, props.className)} />;
});
const containerIsTabletDownCss = "c1b22r9u";
const containerCss = "c18vidse";
const Container = forwardRef((props, ref) => {
  const isTabletDown = useDeviceType('isTabletDown');
  return <Menu ref={ref} {...props} className={classNames(containerCss, {
    [containerIsTabletDownCss]: isTabletDown
  }, props.className)} />;
});
const styledFieldsetCss = "s1jtqjf3";
const StyledFieldset = forwardRef((props, ref) => <Fieldset ref={ref} {...props} className={classNames(styledFieldsetCss, props.className)} />);
const styledButtonRedesignStylingCss = "s42b4ks";
const styledButtonIsPhoneCss = "s7prq7v";
const styledButtonCss = "s19mvgqc";
const StyledButton = forwardRef((props, ref) => {
  const {
    redesignStyling,
    ...restProps
  } = props;
  const responsive = false;
  const size = 'small';
  const isPhone = useDeviceType('isPhone');
  return <Button ref={ref} {...restProps} responsive={responsive} size={size} className={classNames(styledButtonCss, {
    [styledButtonRedesignStylingCss]: redesignStyling,
    [styledButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const CopyButton = ({
  day,
  weekdayRules,
  onApply,
  redesignStyling,
  v4Styling = false
}) => {
  const [toggleDropdown, Dropdown, isExpanded] = useDropdown();
  const [selectedDays, setSelectedDays] = useState({
    [day]: true
  });
  const dayNames = I18n.t('date.day_names_hash');
  const selectDay = selectedDay => {
    setSelectedDays({
      ...selectedDays,
      [selectedDay]: !selectedDays[selectedDay]
    });
  };
  const applyAvailabilityRules = () => {
    const targetDays = Object.keys(selectedDays).filter(selectedDay => selectedDay !== day && selectedDays[selectedDay]);
    toggleDropdown();
    if (targetDays.length > 0) {
      onApply(day, targetDays);
    }
  };
  useEffect(() => {
    if (!isExpanded) {
      setSelectedDays({
        [day]: true
      });
    }
  }, [day, isExpanded]);
  const useRedesignStyling = redesignStyling || v4Styling;
  const DropdownMenu = useRedesignStyling ? ViewportDropdownMenu : Container;
  return <div className={classNames(copyButtonWrapperCss, {
    [copyButtonWrapperIsV4Css]: v4Styling
  })}>
      <IconButton aria-expanded={isExpanded} aria-label={I18n.t('publisher.availability.schedules.copy_times.title', {
      day: dayNames[day]
    })} onClick={toggleDropdown} size={useRedesignStyling ? 'small' : 'normal'} icon={v4Styling ? IconCopy : undefined}>
        {v4Styling ? null : <CopyIcon />}
      </IconButton>
      <Dropdown>
        <DropdownMenu>
          <StyledFieldset>
            <Title>{I18n.t('publisher.availability.schedules.copy_times.header')}</Title>
            {Object.entries(weekdayRules).map(([weekday]) => <CheckboxItem key={weekday}>
                  <CheckboxContainer>
                    {dayNames[weekday]}
                    <CheckboxInput checked={selectedDays[weekday] || false} onChange={() => selectDay(weekday)} disabled={day === weekday} />
                  </CheckboxContainer>
                </CheckboxItem>)}
          </StyledFieldset>
          <Group>
            <StyledButton redesignStyling={useRedesignStyling} onClick={applyAvailabilityRules}>
              {I18n.t('publisher.action.apply')}
            </StyledButton>
          </Group>
        </DropdownMenu>
      </Dropdown>
    </div>;
};

require("./copy_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./copy_button.js");